"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CordEmailMergeService = void 0;
const fetch_client_1 = require("./fetch-client");
class CordEmailMergeService extends fetch_client_1.FetchClient {
  constructor(baseUrl) {
    if (CordEmailMergeService.instance) {
      return CordEmailMergeService.instance;
    }
    super();
    if (baseUrl) {
      this.baseUrl = baseUrl;
    }
    CordEmailMergeService.instance = this;
  }
  sendEmailViaTemplate(templateName, data) {
    return this.post(`mailmerge/${templateName}`, data);
  }
}
exports.CordEmailMergeService = CordEmailMergeService;
CordEmailMergeService.instance = null;
